

























































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import EditBaseFlux from '@/components/flux/edit/EditBaseFlux.vue'
import { AloFlux, getDefaultAloFlux } from '@/models/alo/AloFlux'
import * as rules from '@/utils/validationRules'
import { TypeOffre } from '@/enum/TypeOffre'
import { FluxCompressionMode } from '@/enum/FluxCompressionMode'

@Component({
  name: 'EditConfig',    
  components:{EditBaseFlux},  
  props: {   
    mkpEditable:{
      type:Boolean,
      default:true      
    }
  }      
})
export default class EditConfig extends Vue {
  
  private flux = getDefaultAloFlux()
    
  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }

  edit(item:AloFlux) {            
    this.flux =  (this.$refs.baseEdit as EditBaseFlux).edit(item)  
  }  

  get TypeOffre(){        
    return TypeOffre
  }

  get FluxCompressionMode(){        
    return FluxCompressionMode
  }

  
  
}
